import React from "react";
import { devices } from "../mock";

const DevicesMarquee = () => {
  const list = [...devices, ...devices];
  return (
    <section className="py-10 border-y border-emerald-900/40 bg-[#060f1d]/60">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center text-xs uppercase tracking-[0.3em] text-emerald-300/70 mb-4">
          Επισκευάζουμε όλα τα brands
        </div>
      </div>
      <div className="overflow-hidden">
        <div className="marquee-track">
          {list.map((d, i) => (
            <div
              key={i}
              className="text-2xl md:text-3xl font-bold text-emerald-100/40 hover:text-emerald-300 transition-colors px-6"
            >
              {d}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DevicesMarquee;
